import React, {useContext} from 'react'

import {Theme, withStyles} from '../../theme'
import {Container, ContainerProps} from '..'
import {LayoutContext} from './context'
import {LayoutTypes} from './types'

const layoutMapper: Partial<Record<LayoutTypes, ContainerProps['maxWidth']>> = {
  fullContent: false,
}

/** @deprecated */
const LayoutContent: React.FC<React.PropsWithChildren<ContainerProps>> = props => {
  const layout = useContext(LayoutContext)
  const maxWidth = props.maxWidth || layoutMapper[layout]

  return <Container {...props} maxWidth={maxWidth} />
}

export default withStyles(
  (theme: Theme) => ({
    root: {
      paddingTop: theme.go.schemes.spacing.units.XL,
    },
  }),
  {name: LayoutContent.name},
)(LayoutContent)
